<template>
  <!-- 表格内的文件列组件 多处用到,没有都复用后续可以复用...-->
  <div class="progress-column">
    <el-progress v-if="showProgress"
                 :color="customColorMethod"
                 :text-inside="true"
                 :stroke-width="12"
                 :format="format"
                 :percentage="percentage > 100 ? 100 : percentage"></el-progress>
    <slot name="isNaNData" v-else></slot>
  </div>
</template>

<script>
export default {
  name: 'progress-column',
  props: {
    data: [String, Number]
  },
  data () {
    return {
      showProgress: false
    }
  },
  watch: {
    percentage: {
      handler (val) {
        if (val !== undefined) {
          this.showProgress = true
        }
      },
      immediate: true
    }
  },
  computed: {
    percentage () {
      let percentage
      if (this.data !== undefined && this.data !== '' && !isNaN(Number(this.data))) {
        // 精确到4位小数,这样转百分比之后还有两位
        percentage = this.$_.round(this.data, 4) * 100
      }
      return percentage
    }
  },
  methods: {
    // 超过100%的数值展示
    format () {
      return this.percentage > 100 ? this.percentage + '%' : `${this.percentage}%`
    },
    customColorMethod () {
      if (this.percentage < 26) {
        return '#F67570'
      } else if (this.percentage < 61) {
        return '#F7C030'
      } else if (this.percentage < 101) {
        return '#95C869'
      } else {
        return '#f96948'
      }
    }
  }
}
</script>
<style lang="scss">
  .progress-column{
    .el-progress{
      .el-progress-bar{
        border: 1px solid #E6E6E6;
        padding: .2px;
        .el-progress-bar__outer,.el-progress-bar__inner{
          border-radius: unset;
        }
        .el-progress-bar__outer{
          background-color: #ffffff;
        }
        .el-progress-bar__inner{
          line-height: 0;
          text-align: center;
          .el-progress-bar__innerText{
            color: #181818;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/tableComponents/progress-column.vue